import Vue from 'vue';
import { getAvailableAgents } from 'widget/api/agent';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';

const state = {
  inbox: {}
};

export const getters = {
  getInbox: $state => $state.inbox
};

export const actions = {
  update: async ({ commit }, data) => {
    commit('setInbox', data);
  },
};

export const mutations = {
  setInbox($state, data) {
    Vue.set($state, 'inbox', data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
